import React from 'react';
import '../Section.css';
import '../../App.css';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations';
import LabsCarousel from '../LabsCarousel';
import LabsBottomCarousel from '../LabsBottomCarousel';

function LabsPage() {
  const { language } = useLanguage();

  return (
    <div className="page labs-page">
      <div className="halftone-bg xfade-section">
        <LabsCarousel />
      </div>

      {/* Full-width black textbox */}
      <div className="full-width-text-panel">
        <p>
          {t('labs.para1', language)}
        </p>
      </div>

      {/* Bottom carousel replacing the second photo */}
        <div className="halftone-bg xfade-section"><LabsBottomCarousel /></div>

      {/* Another full-width black textbox */}
      <div className="full-width-text-panel">
        <p>
          {t('labs.para2', language)}
        </p>
      </div>

      {/* Pink collaboration textbox */}
      <div className="collaboration-panel">
        <p>
          {t('labs.collabLine1', language)}<br/>
          {t('labs.collabLine2', language)}<br/>
          {t('labs.collabLine3', language)} <Link to="/contact" className="inline-link" onClick={() => window.scrollTo(0, 0)}>{t('labs.here', language)}</Link>
        </p>
      </div>

      {/* Floorplan section with black background */}
      <div className="floorplan-section">
        <div className="floorplan-container">
          <img
            src={process.env.PUBLIC_URL + '/images/labs/labs_floorplan.png'}
            alt="Labs Floorplan"
            className="floorplan-image"
          />
        </div>
      </div>

    </div>
  );
}

export default LabsPage;
